import { Route, Router, useParams } from "@solidjs/router";
import { ApiProvider } from "./api/provider.tsx";
import { apiPrefix, makeApi } from "./api/client.ts";
import { I18nProvider } from "./i18n/provider.tsx";
import { FillPage } from "./routes/fill/FillPage.tsx";
import { RelevancyPage } from "./routes/fill/RelevancyPage.tsx";
import { AdminShell } from "./routes/admin/AdminShell.tsx";
import { AuthorsPage } from "./routes/admin/AuthorsPage.tsx";
import { CatalogPage } from "./routes/admin/CatalogPage.tsx";
import { CustomerPage, CustomersPage } from "./routes/admin/CustomersPage.tsx";
import { CustomerPersonaPage } from "./routes/portal/CustomerPersonaPage.tsx";
import { StartPage } from "./routes/portal/StartPage.tsx";
import { ComparePage } from "./routes/admin/ComparePage.tsx";
import { DashboardPage } from "./routes/admin/DashboardPage.tsx";
import { HistoryPage } from "./routes/admin/HistoryPage.tsx";
import { PersonasPage } from "./routes/admin/PersonasPage.tsx";
import { ProductPage, ProductsPage } from "./routes/admin/ProductsPage.tsx";
import { OverviewPage } from "./routes/admin/OverviewPage.tsx";
import { ViewsPage } from "./routes/admin/ViewsPage.tsx";
import {
  QuestionnairePage,
  QuestionnairesPage,
} from "./routes/admin/QuestionnairesPage.tsx";
import { ReportPage, ReportsPage } from "./routes/admin/ReportsPage.tsx";
import type { Api } from "./api/client.ts";
import type { JSX } from "solid-js";

/** Reads the magic-link token from the URL and hands it to the page. */
const FillRoute = () => {
  const params = useParams<{ token: string }>();
  return <FillPage token={params.token} />;
};

/** The same, for the relevancy link a persona rates their priorities through. */
const RelevancyRoute = () => {
  const params = useParams<{ token: string }>();
  return <RelevancyPage token={params.token} />;
};

const Admin = (props: { children?: JSX.Element }) => <AdminShell>{props.children}</AdminShell>;

export type AppProps = {
  /** Swapped for a stub in tests; production talks to the REST API. */
  api?: Api;
};

export const App = (props: AppProps) => (
  <I18nProvider>
    <ApiProvider value={props.api ?? makeApi(apiPrefix)}>
      <Router>
        <Route path="/q/:token" component={FillRoute} />
        <Route path="/r/:token" component={RelevancyRoute} />
        <Route path="/" component={Admin}>
          <Route path="/" component={StartPage} />
          <Route path="/customers" component={CustomersPage} />
          <Route path="/customers/:id" component={CustomerPage} />
          <Route path="/persona" component={CustomerPersonaPage} />
          <Route path="/catalog" component={CatalogPage} />
          <Route path="/history/:entityType/:id" component={HistoryPage} />
          <Route path="/products" component={ProductsPage} />
          <Route path="/products/:id" component={ProductPage} />
          <Route path="/personas" component={PersonasPage} />
          <Route path="/authors" component={AuthorsPage} />
          <Route path="/questionnaires" component={QuestionnairesPage} />
          <Route path="/questionnaires/:id" component={QuestionnairePage} />
          <Route path="/views" component={ViewsPage} />
          <Route path="/overview" component={OverviewPage} />
          <Route path="/compare" component={ComparePage} />
          <Route path="/reports" component={ReportsPage} />
          <Route path="/reports/:id" component={ReportPage} />
        </Route>
      </Router>
    </ApiProvider>
  </I18nProvider>
);
